<template>
  <v-app>
    <drawer style="z-index: 10000;"
      :drawer="drawer"
      :mini="drawerMini"
      :sidebarColor="sidebarColor"
      :sidebarTheme="sidebarTheme"
      @hover-change="onDrawerHoverChange"
    >
    </drawer>
    <v-main :class="mainLayoutClass">
   
      <!-- <div
        @click="drawer = false"
        v-if="drawer"
        class="position-absolute drawer-state"
      ></div> -->
      <!-- Add User Menu -->
      <v-row>
        <v-col cols="1" class="mt-5 mb-0 pb-0 d-flex justify-start">
          <!-- Drawer Toggle Button -->
          <v-btn 
            icon 
            @click="toggleDrawerMini"
            class="drawer-toggle-btn"
          >
            <v-icon>{{ drawerMini ? 'mdi-menu' : 'mdi-menu-open' }}</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="10"></v-col>
        <v-col cols="1" class="mt-5 mb-0 pb-0 d-flex justify-end">
          <!-- Alert Menu -->
          <v-menu offset-y content-class="alerts-dropdown">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="mr-2">
                <v-badge
                  :content="unreadAlertsCount"
                  :value="unreadAlertsCount > 0"
                  color="red"
                  right
                  top
                >
                  <v-icon>mdi-bell</v-icon>
                </v-badge>
              </v-btn>
            </template>

            <v-list width="350">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 font-weight-bold">
                    Alerts
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn 
                    text 
                    small 
                    @click="markAllAsRead" 
                    v-if="unreadAlertsCount > 0"
                    :loading="markingAllAsRead"
                    :disabled="markingAllAsRead"
                  >
                    Mark all read
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              
              <v-divider></v-divider>
              
              <v-list-item v-if="notifications.length === 0">
                <v-list-item-content>
                  <div class="text-center grey--text">No unread alerts to display</div>
                </v-list-item-content>
              </v-list-item>
              
              <template v-else>
                <v-list-item 
                  v-for="notification in notifications" 
                  :key="notification.id"
                  @click="viewAlert(notification)"
                  :class="{'unread-alert': !notification.read}"
                >
                  <v-list-item-icon>
                    <v-icon :color="getStatusColor(notification.status)">
                      {{ getStatusIcon(notification.status) }}
                    </v-icon>
                  </v-list-item-icon>
                  
                  <v-list-item-content>
                    <v-list-item-title class="subtitle-2">
                      {{ notification.deviceName }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ notification.status }} - {{ getTimeAgo(notification.timestamp) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
          
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-account-circle</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item to="/profile" router exact>
                <v-list-item-icon>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Profile</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item to="/company" router exact>
                <v-list-item-icon>
                  <v-icon>mdi-office-building</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Company</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>

      <fade-transition :duration="200" origin="center top" mode="out-in">
        <!-- your content here -->
        <router-view></router-view>
      </fade-transition>

      <v-btn
        v-if="$route.params.id && $route.params.sensorId == null"
        :ripple="false"
        icon
        rounded
        color="#fff"
        width="52px"
        height="52px"
        class="
          fixed-plugin-button
          position-fixed
          btn-light
          bg-white
          text-dark
          z-index-9999
        "
        @click="showSettingsDrawer = true"
      >
        <v-icon size="20">fa fa-cog py-2</v-icon>
      </v-btn>
      <v-btn
        v-if="$route.params.sensorId"
        :ripple="false"
        icon
        rounded
        color="#fff"
        width="52px"
        height="52px"
        class="
          fixed-plugin-button
          position-fixed
          btn-light
          bg-white
          text-dark
          z-index-9999
        "
        @click="showDeviceDrawer = true"
      >
        <v-icon size="20">fa fa-cog py-2</v-icon>
      </v-btn>

      <settings-drawer
        v-if="$route.params.id && !$route.params.sensorId"
        :showSettingsDrawer="showSettingsDrawer"
        @toggleSettingsDrawer="toggleSettingsDrawer"
        @updateSidebarColor="updateSidebarColor"
        @updateSidebarTheme="updateSidebarTheme"
        @toggleNavbarPosition="toggleNavbarPosition"
      >
      </settings-drawer>
      <device-settings-drawer
        v-if="$route.params.sensorId"
        :showSettingsDrawer="showDeviceDrawer"
        @toggleSettingsDrawer="toggleDeviceDrawer"
        @updateSidebarColor="updateSidebarColor"
        @updateSidebarTheme="updateSidebarTheme"
        @toggleNavbarPosition="toggleNavbarPosition"
      >
      </device-settings-drawer>
    </v-main>
  </v-app>
</template>
<script>
// /* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { fetchObjects, updateSingleObjectToFirebase as updateObject } from "@/services/firebase-helpers";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import { FadeTransition } from "vue2-transitions";
import Drawer from "@/components/Drawer.vue";
import AppBar from "@/components/AppBar.vue";
import SettingsDrawer from "@/components/Widgets/SettingsDrawer.vue";
import DeviceSettingsDrawer from "@/components/Widgets/DeviceSettingsDrawer.vue";
export default {
  components: {
    FadeTransition,
    Drawer,
    AppBar,
    SettingsDrawer,
    DeviceSettingsDrawer,
  },
  data() {
    return {
      drawer: true,
      drawerMini: false,
      drawerIsHovered: false,
      showSettingsDrawer: false,
      showDeviceDrawer: false,
      sidebarColor: "white",
      sidebarTheme: "white",
      navbarFixed: false,
      notifications: [],
      unreadAlertsCount: 0,
      alertPollingInterval: null,
      markingAllAsRead: false,
    };
  },
  computed: {
    showSettings() {
      return (
        this.$route.fullPath.includes("/location/") &&
        this.$route.fullPath.includes("/device/") !== true
      );
    },
    showDevice() {
      return (
        this.$route.fullPath.includes("/location/") &&
        this.$route.fullPath.includes("/device/")
      );
    },
    mainLayoutClass() {
      if (this.drawerMini && !this.drawerIsHovered) {
        return 'drawer-mini-active';
      } else if (this.drawerMini && this.drawerIsHovered) {
        return 'drawer-mini-hovered';
      } else {
        return 'drawer-normal';
      }
    },
  },
  watch: {
    drawerMini: {
      handler(newVal) {
        this.$nextTick(() => {
          setTimeout(() => {
            // Layout adjustments if needed
          }, 100);
        });
      },
      immediate: true
    }
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
    toggleSettingsDrawer(value) {
      this.showSettingsDrawer = value;
    },
    toggleDeviceDrawer(value) {
      this.showDeviceDrawer = value;
    },
    updateSidebarColor(value) {
      this.sidebarColor = value;
    },
    updateSidebarTheme(value) {
      this.sidebarTheme = value;
    },
    toggleNavbarPosition(value) {
      this.navbarFixed = value;
    },
    getStatusColor(status) {
      if (!status) return 'grey';
      switch (status.toLowerCase()) {
        case 'critical':
          return 'red';
        case 'warning':
          return 'amber';
        case 'secure':
          return 'green';
        default:
          return 'grey';
      }
    },
    
    getStatusIcon(status) {
      if (!status) return 'mdi-alert-circle-outline';
      switch (status.toLowerCase()) {
        case 'critical':
          return 'mdi-alert-circle';
        case 'warning':
          return 'mdi-alert';
        case 'secure':
          return 'mdi-check-circle';
        default:
          return 'mdi-information';
      }
    },
    
    getTimeAgo(timestamp) {
      if (!timestamp) return 'Unknown';
      
      const now = new Date();
      const alertTime = new Date(timestamp);
      const diffMs = now - alertTime;
      
      const diffSec = Math.floor(diffMs / 1000);
      if (diffSec < 60) return `${diffSec} sec ago`;
      
      const diffMin = Math.floor(diffSec / 60);
      if (diffMin < 60) return `${diffMin} min ago`;
      
      const diffHour = Math.floor(diffMin / 60);
      if (diffHour < 24) return `${diffHour} hr ago`;
      
      const diffDay = Math.floor(diffHour / 24);
      return `${diffDay} day${diffDay > 1 ? 's' : ''} ago`;
    },
    
    async fetchAlerts() {
      try {
        const allAlerts = await fetchObjects("alerts");
        
        if (!allAlerts || allAlerts.length === 0) {
          this.notifications = [];
          this.unreadAlertsCount = 0;
          return;
        }
        
        const filteredAlerts = allAlerts.filter(alert => 
          alert.status && 
          (alert.status.toLowerCase() === 'critical' || 
           alert.status.toLowerCase() === 'warning') &&
          alert.read !== true
        );
        
        this.unreadAlertsCount = filteredAlerts.length;
        
        const sortedAlerts = filteredAlerts.sort((a, b) => {
          const dateA = new Date(a.timestamp);
          const dateB = new Date(b.timestamp);
          return dateB - dateA;
        });
        
        this.notifications = sortedAlerts.slice(0, 5).map(alert => {
          const deviceName = (alert.deviceId && alert.deviceId.trim()) ? `Device ${alert.deviceId.split('-').pop()}` : 'Unknown Device';
          
          return {
            ...alert,
            deviceName
          };
        });
      } catch (error) {
        console.error("Error fetching alerts for notification:", error);
      }
    },
    
    async markAllAsRead() {
      try {
        const unreadAlerts = this.notifications.filter(alert => !alert.read);
        
        if (unreadAlerts.length === 0) return;
        
        this.markingAllAsRead = true;
        
        for (const alert of unreadAlerts) {
          await updateObject("alerts", alert.id, { ...alert, read: true });
        }
        
        this.notifications = [];
        this.fetchAlerts();
        this.markingAllAsRead = false;
      } catch (error) {
        console.error("Error marking alerts as read:", error);
        this.markingAllAsRead = false;
      }
    },
    
    viewAlert(notification) {
      if (!notification.read) {
        const index = this.notifications.findIndex(n => n.id === notification.id);
        if (index !== -1) {
          this.notifications[index].read = true;
          
          updateObject("alerts", notification.id, { ...notification, read: true })
            .then(() => {
              this.notifications = this.notifications.filter(n => n.id !== notification.id);
              this.unreadAlertsCount = Math.max(0, this.unreadAlertsCount - 1);
              setTimeout(() => this.fetchAlerts(), 500);
            })
            .catch(error => {
              console.error("Error marking alert as read:", error);
              if (index !== -1 && this.notifications[index]) {
                this.notifications[index].read = false;
              }
            });
        }
      }
      
      if (notification.deviceId) {
        this.$router.push({
          path: `/device/${notification.deviceId}/alerts`,
          query: { openAlert: notification.id }
        });
      }
    },
    toggleDrawerMini() {
      this.drawerMini = !this.drawerMini;
    },
    onDrawerHoverChange(isHovering) {
      this.drawerIsHovered = isHovering;
    },
  },
  mounted() {
    this.initScrollbar();
    this.fetchAlerts();
    
    this.alertPollingInterval = setInterval(() => {
      this.fetchAlerts();
    }, 30000);
  },
  beforeDestroy() {
    // Clear the polling interval when component is destroyed
    if (this.alertPollingInterval) {
      clearInterval(this.alertPollingInterval);
    }
  },
};
</script>
<style lang="scss">
.user-menu {
  top: 20px;
  right: 20px;
  z-index: 9999;
}

.user-menu-btn {
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  &:hover {
    background-color: #f5f5f5;
  }
}

.unread-alert {
  background-color: rgba(25, 118, 210, 0.08);
  font-weight: 500;
}

.alerts-dropdown {
  z-index: 10000 !important; /* Ensure alerts dropdown is above leaflet map */
}

/* Drawer toggle button styling */
.drawer-toggle-btn {
  background-color: transparent !important;
  box-shadow: none !important;
  color: #666 !important;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.04) !important;
    color: #333 !important;
  }
  
  &:before {
    background-color: transparent !important;
  }
}

/* Main content area responsive to drawer state */
.v-main {
  transition: padding-left 0.3s ease !important;
}

/* Override Vuetify's default drawer padding */
::v-deep .v-application--is-ltr .v-main {
  padding-left: 256px !important;
  transition: padding-left 0.3s ease !important;
}

/* Normal drawer state */
.v-main.drawer-normal {
  padding-left: 256px !important;
}

/* Mini drawer state (collapsed) */
.v-main.drawer-mini-active {
  padding-left: 80px !important;
}

/* Mini drawer state (hovered/expanded) */
.v-main.drawer-mini-hovered {
  padding-left: 256px !important;
}

/* Deep selectors for Vuetify override */
::v-deep .v-application--is-ltr .v-main.drawer-normal {
  padding-left: 256px !important;
}

::v-deep .v-application--is-ltr .v-main.drawer-mini-active {
  padding-left: 80px !important;
}

::v-deep .v-application--is-ltr .v-main.drawer-mini-hovered {
  padding-left: 256px !important;
}

/* Force override with highest specificity - THIS WAS KEY */
.v-application .v-main.drawer-mini-active {
  padding-left: 80px !important;
}

.v-application .v-main.drawer-mini-hovered {
  padding-left: 256px !important;
}

.v-application .v-main.drawer-normal {
  padding-left: 256px !important;
}

/* Additional override to ensure the change takes effect */
::v-deep .v-application .v-main.drawer-mini-active {
  padding-left: 80px !important;
}

::v-deep .v-application .v-main.drawer-mini-hovered {
  padding-left: 256px !important;
}

/* Nuclear option - force with body selector */
body .v-application .v-main.drawer-mini-active {
  padding-left: 80px !important;
}

body .v-application .v-main.drawer-mini-hovered {
  padding-left: 256px !important;
}
</style>
